<template>
  <div style="width: 100%">
    <Modal
      v-if="modal_entrada"
      :modalContentCustom="'height: 100% !important; width: 100% !important; padding: 0px !important; margin: 0px;'"
      style="padding: 0px"
    >
      <template v-slot:body>
        <div class="img_background" :style="backgroundImage">
          <button class="button" @click="prosseguir()">Prosseguir</button>
        </div>
      </template>
    </Modal>
  </div>
</template>

<script>
import Modal from "./Modal.vue";
import FirebaseHelper from "@/service/FirebaseHelper.js";
import { mapGetters, mapActions } from "vuex";

export default {
  components: {
    Modal,
  },
  data() {
    return {
      firebaseHelper: new FirebaseHelper(),
      public_url: "",
      mensagem_entrada: null,
      modal_entrada: false,
    };
  },
  computed: {
    ...mapGetters({
      participante: "participante",
      isRP: "isRP",
    }),
    backgroundImage() {
      return `background-image: url("${this.public_url}")`;
    },
  },
  created() {
    this.loadModal()
  },
  methods: {
    ...mapActions(["atualizarEstadoParticipante"]),
    loadModal() {
      if (!this.isRP) {
        let tag_msg = ((this.participante.setting || {}).mensagem_entrada || {}).tag || null;
        if (tag_msg) {
          if (
            this.participante &&
            this.participante.mensagens &&
            (this.participante.mensagens.entrada_app || {}).tag === tag_msg
          ) {
            this.modal_entrada = false;
          } else if (!this.participante.data.cadastro.adesao_digital) {
            this.mensagem_entrada = this.participante.setting.mensagem_entrada;
            this.public_url = this.participante.setting.mensagem_entrada.url_img;
            this.modal_entrada = true;
          } else {
            this.modal_entrada = false;
          }
        } else {
          this.modal_entrada = false;
        }
      } else {
        this.modal_entrada = false;
      }
    },
    async prosseguir() {
      if (!this.isRP) {
        let response = await this.firebaseHelper.mensagemEntradaLida(
          this.participante.chave,
          this.mensagem_entrada.tag
        );
        if (response) {
          this.participante.mensagens = {
            entrada_app: response,
          };
          this.atualizarEstadoParticipante(this.participante);
        }
        this.modal_entrada = false;
      }
    },
  },
};
</script>

<style scoped>
button:disabled {
  background: transparent;
  color: transparent;
}
.modal {
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 5;
  padding-top: 100px;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgb(0, 0, 0); /* Fallback color */
  background-color: rgba(0, 0, 0, 0.9); /* Black w/ opacity */
}
/* Conteúdo do Modal */
.modal-content {
  width: 90%;
  height: 90%;
  padding: 10px;
  margin: 10% 5%;
  background-color: #fefefe;
  border: 1px solid #888;
  border-radius: 8px;
}
/* Botão de fechar modal */
.close {
  color: #aaaaaa;
  float: right;
  font-size: 28px;
  font-weight: 200;
}
.close:hover,
.close:focus {
  color: #000;
  text-decoration: none;
  cursor: pointer;
}
.img_background {
  background-repeat: no-repeat;
  background-color: black;
  min-height: 100%;
  background-position: center;
  background-size: contain;
  display: flex;
  align-items: end;
  margin: 0px -2px;
}
.button {
  margin-left: 10%;
  margin-right: 10%;
  margin-bottom: 10%;
}
</style>
